/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;min-height:130px;display:block}.app-modal-content[_ngcontent-%COMP%]{padding:0 20px;font-size:16px;text-indent:unset}.content-message[_ngcontent-%COMP%]{white-space:pre-line}\n/*# sourceMappingURL=confirm-modal.component.css.map*/"];
export { styles as styles };
